module.exports = {
  'lang': 'zh-cn',
  'ok': '确定',
  'cancel': '取消',
  'en-us': {
    'ok': 'ok',
    'cancel': 'cancel'
  }
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-popconfirm/src/i18n.js